import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { StorageUtilsService } from "app/services/storage-utils/storage-utils.service";
import { setAppContext } from "../actions/context.actions";

@Injectable()
export class ContextEffect {
  actions$ = inject(Actions);
  _router = inject(Router);
  _storageUtilsService = inject(StorageUtilsService);

  setContextEff$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(setAppContext),
        map((action) => action.appContext),
        switchMap((context) => {
          /** set selected context value in storage */
          this._storageUtilsService.setAppContext(context);
          return of(null);
        }),
      );
    },
    { dispatch: false },
  );
}
